export default "__VITE_ASSET__BwzshHEV__"